import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Inrejected(state = initialState, action) {
  switch (action.type) {
    case userConstants.INREJECTED_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.INREJECTED_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.INREJECTED_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}